import React from 'react';

export function getValidationErrorContent(errors, orderNumber) {
        
    return <div>
            <b>Unable to release order {orderNumber}</b><br />
            <span>Please contact customer service for further support.</span><br/>
            <span>Your order has been saved with status WO preliminary, due to the following errors:</span><br /><br />
        {errors.map((error) => {
            return (
                error.HasErrors
                    ? <div>

                        <span>{error.ErrorMessage}</span>
                        <ul>
                            {error.OrderItems.map((order) => {
                                return (
                                    <li>
                                        <span>{order.OrderItemNumber === -1 ? '' : order.OrderItemNumber + ' - '} {order.ProductCode} - {order.Weight}</span>
                                    </li>
                                )

                            })}
                        </ul>
                    </div>
                    : null

            )
        })}
    </div>

}